// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";
import { PasswordResetRequest } from "./types";

interface paramsType {
  data: PasswordResetRequest;
  notificationID: string | number;
}

export function useResetPasswordMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function resetPassword(params: paramsType): Promise<any> {
    const response = await api.post<any>("account/resetpassword", params.data);

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: resetPassword,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
